import styled from "@emotion/styled";
import { DSButton } from "@hundred5/design-system";
import { Trans } from "@lingui/react/macro";

export const CandidatePortalCta = () => {
  return (
    <CandidatePortalCtaContainer>
      <Trans>Want to be the first to know about similar opportunities?</Trans>{" "}
      <Trans>Join our Candidate Portal to get personalized Job Offers.</Trans>
      <DSButton
        onClick={() => {
          window.open(
            `https://toggl.com/hire/free-self-assessment-tests`,
            "_blank",
          );
        }}
      >
        <Trans>Join Candidate Portal</Trans>
      </DSButton>
    </CandidatePortalCtaContainer>
  );
};

const CandidatePortalCtaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
  color: ${(props) => props.theme.typography.colorPrimary};
  font-size: 14px;
  font-weight: 400;
`;
